import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route, Navigate} from 'react-router';

import Authentication from './auth/Authentication';
import MagicLink from './auth/MagicLink';
import Assistant from './assistant/Assistant';
import EventFeedback from './feedback/EventFeedback';
import CaregiverDetail from './caregiver/CaregiverDetail';

const Router = () => {
  return (
    <Routes>
      <Route path="/signout" element={<Navigate to="/" />} />
      <Route path="/magic-link" Component={MagicLink} />
      <Route path="/assistant" Component={Assistant} />
      <Route path="/feedback/event/:eventFeedbackRn" Component={EventFeedback} />
      <Route path="/caregivers/:caregiverRnOrShortId" Component={CaregiverDetail} />

      <Route path="*" Component={Authentication} />
    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

